import {DeadlineFilterItemType, DeadlineSearchParamType} from "../interface";
import {Control, UseFormRegister} from "react-hook-form";
import InputNumberUc from "../../../../../components/common/number/InputNumberUc";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    watchSearchParam: DeadlineSearchParamType
    register: UseFormRegister<DeadlineSearchParamType>
    watchFilterItem: DeadlineFilterItemType
    registerFilter: UseFormRegister<DeadlineFilterItemType>
    btnSearch: () => any
    btnSaveTaxEndDate: () => any
    btnApplyExchangeRate: () => any
    controlFilter: Control<DeadlineFilterItemType>
}

export default function Filter({
                                   watchSearchParam,
                                   register,
                                   watchFilterItem,
                                   registerFilter,
                                   btnSearch,
                                   btnSaveTaxEndDate,
                                   btnApplyExchangeRate,
                                   controlFilter
                               }: PropsType) {

    /* 내부수정: 키워드 검색, 날짜 등 위치 조정*/  
    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">마감 검색</h3>
            <div className="filter_toolbar"></div>
        </div>
        <div className="row">
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">조건</label>
                    <select className="form-select ms-40px"
                            value={watchSearchParam.endFlag}
                            {...register("endFlag")}>
                        <option value={"0"}>전체</option>
                        <option value={"Y"}>마감</option>
                        <option value={"N"}>미 마감</option>
                    </select>
                    {/* 내부수정: 마감구분 필터 추가 */}
                    <select className="form-select ms-5px"
                            value={watchSearchParam.endType}
                            {...register("endType")}>
                        <option value={"0"}>전체</option>
                        <option value={"1"}>일반</option>
                        <option value={"2"}>월마감</option>
                        <option value={"3"}>역발행</option>
                    </select>
                    {/*<button className="btn btn-info btn_search">*/}
                    {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회*/}
                    {/*</button>*/}
                    <div className="frm_field input_date">
                        <input type="date"
                               className="form-control"
                               value={watchSearchParam.fromDate}
                               {...register("fromDate")}/>
                        <span className="txt_range">~</span>
                        <input type="date"
                               className="form-control me-0"
                               value={watchSearchParam.toDate}
                               {...register("toDate")}/>
                    </div>
                </div>
                <AuthorityChecker authorityNames={['endWriteYn']}>
                    <div className="frm_row search justify-content-start">
                        <label htmlFor="" className="form-label frm_label">마감일</label>
                        <input type="date" className="form-control w-150px"
                               value={watchFilterItem.taxEndDate}
                               {...registerFilter("taxEndDate")}/>
                        <button className="btn btn-info btn_search" onClick={btnSaveTaxEndDate}>저장</button>
                    </div>
                </AuthorityChecker>
            </div>

            <div className="col-6">
                <div className="frm_row">
                    <label htmlFor="" className="form-label frm_label">검색어</label>
                    <input type="text" className="form-control w-100px me-5px"
                        placeholder="담당자"
                        {...register("keyword1")} 
                        onKeyDown={(e) => { if (e.key === 'Enter') btnSearch(); }}/>
                    <input type="hidden" {...register("keywordType1")} />
                    <input type="text" className="form-control w-250px me-5px"
                        placeholder="매출처"
                        {...register("keyword2")} 
                        onKeyDown={(e) => { if (e.key === 'Enter') btnSearch(); }}/>
                    <input type="hidden" {...register("keywordType2")} />

                    <button className="btn btn-info btn_search" onClick={btnSearch}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                    </button>
                </div>

                <AuthorityChecker authorityNames={['endWriteYn']}>
                    <div className="frm_row search justify-content-start">
                        <label htmlFor="" className="form-label frm_label">환율 일괄 적용</label>
                        <InputNumberUc name={"newDExchangeRate"} control={controlFilter}/>
                        {/*<input type="text"
                           className="form-control me-0 w-150px"
                           value={watchFilterItem.newDExchangeRate}
                           {...registerFilter("newDExchangeRate")}/>*/}
                        <button className="btn btn-info btn_search w-80px" onClick={btnApplyExchangeRate}>적용</button>
                    </div>
                </AuthorityChecker>
            </div>
        </div>
    </div>
}